import { ErrorHandler } from '@angular/core';

export interface IAngularErrorHandler extends ErrorHandler {}
